import Vue from 'vue'
import Component from 'vue-class-component'
import Configuration from '@/models/dackpartner/Configuration'
import SupplierConfig from '@/models/dackpartner/SupplierConfig'

@Component
export default class DackpartnerSupplierMixin extends Vue {
  // These properties should be available in components that use this mixin
  protected availableSuppliers!: any[]
  protected supplierGuiData!: any[]
  protected configuration!: Configuration

  protected getSupplierName(supplierId: number): string {
    const supplier = this.availableSuppliers.find((s) => s.id === supplierId)
    return supplier ? supplier.name : this.$t('Unknown Supplier')
  }

  protected getBrandName(supplierId: number, brandId: number): string {
    for (let i = 0; i < this.configuration.suppliersConfig.length; i++) {
      const supplierConfig = this.configuration.suppliersConfig[i]
      if (supplierConfig.supplierId === supplierId) {
        const brand = this.supplierGuiData[i].availableBrands.find((b: any) => b.id === brandId)
        if (brand) {
          return brand.name
        }
      }
    }
    return this.$t('Unknown Brand')
  }

  protected getSupplierLabels(): string[] {
    const labels: string[] = []
    for (const supplierConfig of this.configuration.suppliersConfig) {
      if (supplierConfig.supplierId && supplierConfig.brandId) {
        const supplierName = this.getSupplierName(supplierConfig.supplierId)
        const brandName = this.getBrandName(supplierConfig.supplierId, supplierConfig.brandId)
        labels.push(`${supplierName} - ${brandName}`)
      }
    }
    return labels
  }

  protected getSupplierLabel(supplierConfig: SupplierConfig): string {
    if (!supplierConfig.supplierId) {
      return this.$t('No supplier selected')
    }
    return this.getSupplierName(supplierConfig.supplierId)
  }

  protected getBrandLabel(supplierConfig: SupplierConfig): string {
    if (!supplierConfig.brandId) {
      return this.$t('No brand selected')
    }
    return this.getBrandName(supplierConfig.supplierId, supplierConfig.brandId)
  }

  protected getSupplierBrandLabel(supplierConfig: SupplierConfig): string {
    return this.getSupplierLabel(supplierConfig) + ' - ' + this.getBrandLabel(supplierConfig)
  }
}
